// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__X1i4S {
  overflow-y: scroll;
  scroll-behavior: smooth; }
  .styles_container__X1i4S > div:first-child {
    display: flex;
    justify-content: space-between;
    position: fixed; }
    .styles_container__X1i4S > div:first-child .styles_headerChildren__Z1SLw {
      margin: 0rem 2rem; }
      .styles_container__X1i4S > div:first-child .styles_headerChildren__Z1SLw button {
        margin: 0rem 1rem; }

.styles_footerLink__PyeFM {
  margin: 0rem 0.5rem; }

.styles_dot__IlRBd {
  margin: 0rem 0.5rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/screens/LandingPage/styles.module.scss"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,uBAAuB,EAAA;EAFzB;IAII,aAAa;IACb,8BAA8B;IAC9B,eAAe,EAAA;IANnB;MAQM,iBAAiB,EAAA;MARvB;QAUQ,iBAAiB,EAAA;;AAQzB;EACE,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.container {\n  overflow-y: scroll;\n  scroll-behavior: smooth;\n  & > div:first-child {\n    display: flex;\n    justify-content: space-between;\n    position: fixed;\n    .headerChildren {\n      margin: 0rem 2rem;\n      button {\n        margin: 0rem 1rem;\n      }\n    }\n  }\n}\n\n\n\n.footerLink {\n  margin: 0rem 0.5rem;\n}\n\n.dot {\n  margin: 0rem 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__X1i4S`,
	"headerChildren": `styles_headerChildren__Z1SLw`,
	"footerLink": `styles_footerLink__PyeFM`,
	"dot": `styles_dot__IlRBd`
};
export default ___CSS_LOADER_EXPORT___;
